import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";

const Add = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    title: "",
    file: "",
    image: null,
    image_url: "",
    video: null,
    video_url: "",
  });

  const savePosts = () => {
    if (isValidForm()) {
      setError(false);
      setLoading(true);
      const prodFormData = new FormData();
      prodFormData.append("title", formData.title);
      if (formData.image) {
        prodFormData.append("image", formData.image);
      }
      if (formData.video) {
        prodFormData.append("video", formData.video);
      }
      if (id) {
        prodFormData.append("id", id);
      }
      const pUrl = id ? API_URL.POST_UPDATE : API_URL.POST_SAVE;
      axios
        .post(pUrl, prodFormData)
        .then((res) => {
          if (res.data.status === 1) {
            let message = id
              ? "Posts Updated Successfully."
              : "Posts Created Successfully.";
            toast.success(message, { autoClose: 3000, position: "top-right" });
            setLoading(false);
            navigate("/admin/posts");
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(true);
        })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.POST_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          title: res.data.data.title ? res.data.data.title : "",
          file: res.data.data.file ? res.data.data.file : "",
          image_url: res.data.data.image ? res.data.data.image : "",
          video_url: res.data.data.video ? res.data.data.video : "",
        });
      }
    });
  };
  const isValidForm = () => {
    if (!formData.title) return false;
    if (!id && !(formData.image || formData.video)) return false;
    return true;
  };

  const isRequiredField = (key) => {
    return isError && !formData[key];
  };

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Posts</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/posts"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <form onSubmit={(event) => event.preventDefault()}>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        name="title"
                        maxLength={30}
                        value={formData.title}
                        className={
                          isRequiredField("title")
                            ? "form-control required"
                            : "form-control"
                        }
                        id="title"
                        onChange={(event) => {
                          setFormData({
                            ...formData,
                            title: event.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Image</label>
                          <input
                            accept="image/*"
                            type="file"
                            name="image"
                            className={
                              (isRequiredField("image") && !formData.video)
                                ? "form-control required"
                                : "form-control"
                            }
                            disabled={!!formData.video}
                            onChange={(e) => {
                              const file = e.target.files[0];
                              setFormData({
                                ...formData,
                                image: file,
                                video: null,
                              });
                            }}
                          />
                        </div>
                      </div>
                      {formData.image_url && (
                        <div className="col-md-12">
                          <label>Image Preview</label>
                          <div>
                            <a
                              href={formData.image_url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={formData.image_url}
                                height={100}
                                width={100}
                                alt="post_image"
                              />
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Video</label>
                          <input
                            accept="video/*"
                            type="file"
                            name="video"
                            className={
                              (isRequiredField("video") && !formData.image)
                                ? "form-control required"
                                : "form-control"
                            }
                            disabled={!!formData.image}
                            onChange={(e) => {
                              const file = e.target.files[0];
                              setFormData({
                                ...formData,
                                video: file,
                                image: null,
                              });
                            }}
                          />
                        </div>
                      </div>
                      {id && formData.video_url && (
                        <div className="col-md-12 mt-2">
                          <label>Video Preview</label>
                          <div>
                            <video width="150" height="150" controls>
                              <source
                                src={formData.video_url}
                                type="video/mp4"
                              />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group text-right">
                      <button
                        type="submit"
                        onClick={savePosts}
                        // disabled={!isValidForm()}
                        className="btn btn-primary"
                      >
                        {loading ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Watch color={"white"} height={20} width={20} />
                          </div>
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Add;
